























































































import Vue, { PropType } from 'vue'
import { parsePhoneNumber } from 'libphonenumber-js/max'
import { createGenericTopUp } from '@/api/Topup/topup.api'
import { AxiosResponse } from 'axios'
import { CreateTopUpDTO, Product } from '@/utils/interfaces/topup.interface'
import { VueForm } from '@/utils/interfaces'
import { findPhoneNumbersInText } from 'libphonenumber-js'

export default Vue.extend({
  props: {
    products: Array as PropType<Product[]>,
    pretopup: Boolean,
    defaultProduct: { type: String, default: '' },
  },
  data() {
    return {
      rules: {
        required: (v: any) => !!v || this.$t('validation.field-required'),
      },
      crud: {
        client: '',
        phone: '',
        product: this.defaultProduct,
        quantity: 1,
      },
      resume: [] as { number: string; quantity: string }[],
      isValid: true,
      ignore_hold: false,
    }
  },
  computed: {
    hint() {
      let hint = ''
      if (!this.resume.length) {
        return ''
      }
      this.resume.forEach(element => {
        hint += `${element.number}x${element.quantity}\n`
      })
      return hint
    },
    format() {
      return `
        5#######-N
        # ---> ${this.$t('number-digits')}
        N ---> ${this.$t('quantity')} ----> 1 <= N <= 10
      `
    },
    productsGroup() {
      const groups = new Map<string, Product[]>()
      for (const product of this.products) {
        const group = groups.get(product.code)
        if (group) {
          group.push(product)
        } else {
          groups.set(product.code, [product])
        }
      }

      groups.forEach(value => {
        value.sort((a, b) => a.amount - b.amount)
      })

      return Object.fromEntries(groups)
    },
  },
  watch: {
    defaultProduct(v: string) {
      this.crud.product = v
    },
    'crud.phone'(value: string) {
      this.resume = []
      if (!value) {
        this.isValid = true
        return
      }
      const numbers = value.split('\n')
      for (let index = 0; index < numbers.length; index++) {
        const number = numbers[index]
        const [value, quantity, ...rest] = number.split('-')
        if (
          rest[0] ||
          (quantity &&
            (Number(quantity) !== Number(quantity) ||
              Number(quantity) > 10 ||
              Number(quantity) < 1))
        ) {
          this.isValid = false
          return
        }
        try {
          const phone = parsePhoneNumber(value, 'CU')
          if (phone.getType() !== 'MOBILE') {
            this.isValid = false
            return
          }
          this.resume.push({
            number: phone.nationalNumber.toString(),
            quantity: quantity || '1',
          })
        } catch (error) {
          this.isValid = false
          return
        }
      }
      this.isValid = true
    },
  },
  methods: {
    async onCheck(value: boolean) {
      if (value) {
        const response = await this.$alert({
          title: this.$t('confirm_to_send_topups_now'),
          content: this.$t('your_topups_will_be_sent_now'),
          color: 'error',
        })
        if (!response) this.ignore_hold = false
      }
    },
    onPaste(event: ClipboardEvent) {
      event.preventDefault()
      if (event.clipboardData) {
        const values = event.clipboardData.getData('Text')
        const numbers = findPhoneNumbersInText(values, 'CU')
        if (this.crud.phone && !this.crud.phone.endsWith('\n')) {
          this.crud.phone += '\n'
        }
        this.crud.phone += numbers
          .map(number => number.number.nationalNumber)
          .join('\n')
      }
    },
    async createTopUp(): Promise<AxiosResponse<CreateTopUpDTO> | void> {
      if (!this.crud.product) {
        this.$toast.info(this.$t('please_select_a_product_before_continue'))
        return
      }

      const isSure = await this.$alert({
        title: this.$t('confirm_to_send_topups'),
        content: this.$t('confirm_you_are_sure_about_your_selection'),
        color: 'error',
      })

      if (!isSure) return

      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      if (!this.isValid || !this.resume.length) return
      const payload = {
        ignore_hold: this.ignore_hold,
        topup_requests: this.resume.map(item => ({
          phone_number: '+53' + item.number,
          count: parseInt(item.quantity),
          product: this.crud.product,
          client: this.crud.client,
        })),
      }
      // @ts-expect-error
      const response = await createGenericTopUp(payload)
      this.crud.phone = ''
      this.crud.client = ''
      this.crud.product = this.defaultProduct
      form.resetValidation()
      return response
    },
  },
})
